import { PropertyMappingStore } from '../components/App/stores/clientConfigurations/PropertyMappingStore';
import { ComponentInputsStore } from '../components/App/stores/ComponentsInputsStore';
import { FilterPropertyStore } from '../components/App/stores/FilterPropertyStore';
import { GlobalInputsStore } from '../components/App/stores/GlobalInputsStore';
import { TStoreContext } from '../models/app/TStoreContext';

export function setupStoreContext(storeContext: TStoreContext) {
	const manifest = storeContext.manifest;
	storeContext.set('globalInputsStore', new GlobalInputsStore(storeContext, manifest));
	storeContext.set('propertyMappingStore', new PropertyMappingStore(storeContext, manifest));
	storeContext.set('filterPropertyStore', new FilterPropertyStore(storeContext, manifest));
	storeContext.set('componentInputsStore', new ComponentInputsStore(storeContext, manifest));
	/* [Component: stores] */
}
